import React, { useState } from 'react';
import { Box } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

import { showError } from '@utils';
import { useToggleModal } from '@hooks';
import { customerVehiclesServices } from '@services';

import { PermissionsGate } from 'components/common';
import ButtonV2 from 'components/common/ui/ButtonV2/ButtonV2';
import { ModalFormSection, ModalV2 } from 'components/common/modals';
import { ENTITIES_PERMISIONS } from 'components/common/PermissionsGate/constants';

import CustomerVehicleUserForm from './CustomerVehicleUserForm';

import style from './addCustomerVehicleUser.style';

const AddCustomerVehicleUser = ({
  userId,
  dataLoading,
  customerVehicleId,
  onGetCustomerVehicle,
}) => {
  const [loading, setLoading] = useState(false);

  const { isOpen, handleOpen, handleClose } = useToggleModal();

  const handleSubmit = async (values) => {
    const userRole = values.role;
    delete values.role;

    const payload = {
      user: {
        ...values,
      },
      role: userRole,
    };

    try {
      setLoading(true);
      await customerVehiclesServices.createCustomerVehicleUser(
        customerVehicleId,
        payload
      );
      await onGetCustomerVehicle();
      handleClose();
    } catch (error) {
      showError(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <PermissionsGate entity={ENTITIES_PERMISIONS.WriteCustomerVehicles}>
        <ButtonV2 disabled={dataLoading} onClick={handleOpen}>
          <Box sx={style.buttonWrapper}>
            <AddIcon data-testid="AddIcon" fontSize="small" />
            Add User
          </Box>
        </ButtonV2>
      </PermissionsGate>
      <ModalV2
        isOpen={isOpen}
        onClose={handleClose}
        isLoading={loading}
        title="Add User"
      >
        <ModalFormSection>
          <CustomerVehicleUserForm
            onSubmit={handleSubmit}
            onCancel={handleClose}
            userId={userId}
          />
        </ModalFormSection>
      </ModalV2>
    </>
  );
};

export default AddCustomerVehicleUser;
